import { UserSettings } from '../types';
import { EDU_CONFIG, CREDIT_PACKAGES } from '../config';
import { getMostRecentActivePurchase } from './userUtils';

export interface UserLimits {
    maxClasses: number;
    maxStudents: number;
    maxChildren: number;
    maxLearningPlans: number;
    /** Nhóm Bookai (credit / chia sẻ); -1 = không giới hạn */
    maxGroups: number;
}

/** 0 trên gói = dùng baseline hệ thống; -1 = không giới hạn */
const resolvePkgLimit = (pkgValue: number | undefined, defaultValue: number): number => {
    if (pkgValue === -1) return -1;
    if (pkgValue != null && pkgValue > 0) return pkgValue;
    return defaultValue;
};

export const getUserLimits = (user: UserSettings | null): UserLimits => {
    const defaults = {
        maxClasses: EDU_CONFIG.DEFAULT_LIMITS.MAX_CLASSES,
        maxStudents: EDU_CONFIG.DEFAULT_LIMITS.MAX_STUDENTS,
        maxChildren: EDU_CONFIG.DEFAULT_LIMITS.MAX_CHILDREN,
        maxLearningPlans: EDU_CONFIG.DEFAULT_LIMITS.MAX_LEARNING_PLANS,
        maxGroups: EDU_CONFIG.DEFAULT_LIMITS.MAX_GROUPS,
    };

    if (!user) return defaults;

    const activePurchase = getMostRecentActivePurchase(user);
    if (activePurchase) {
        const pkg = CREDIT_PACKAGES.find(p => p.id === activePurchase.packageId);

        if (pkg) {
            return {
                maxClasses: resolvePkgLimit(pkg.maxClasses, defaults.maxClasses),
                maxStudents: resolvePkgLimit(pkg.maxStudents, defaults.maxStudents),
                maxChildren: resolvePkgLimit(pkg.maxChildren, defaults.maxChildren),
                maxLearningPlans: resolvePkgLimit(pkg.maxLearningPlans, defaults.maxLearningPlans),
                maxGroups: resolvePkgLimit(pkg.maxGroups, defaults.maxGroups),
            };
        }
    }

    return defaults;
};

export const checkLimit = (currentCount: number, limit: number): boolean => {
    if (limit === -1) return true; // Unlimited
    return currentCount < limit;
};
